import { api } from '@smena/ui';

export interface AdminUserListItem {
  id: string;
  email: string;
  name: string;
  active: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export interface CreatedAdmin {
  user: AdminUserListItem;
  password: string;
  totpSecret: string;
  otpauthUri: string;
  /** PNG data-URL - QR с otpauth-ссылкой, рисуется сервером (qrcode). */
  qrDataUrl: string;
}

export interface ResetPasswordResult {
  user: AdminUserListItem;
  password: string;
}

export interface ResetTotpResult {
  user: AdminUserListItem;
  totpSecret: string;
  otpauthUri: string;
  qrDataUrl: string;
}

export function fetchAdmins(): Promise<{ items: AdminUserListItem[] }> {
  return api<{ items: AdminUserListItem[] }>('/api/admin/users');
}

export function setAdminActive(id: string, active: boolean): Promise<{ user: AdminUserListItem }> {
  return api(`/api/admin/users/${id}/active`, { method: 'PATCH', json: { active } });
}

export function deleteAdmin(id: string): Promise<{ ok: true }> {
  return api(`/api/admin/users/${id}`, { method: 'DELETE' });
}

export function resetAdminPassword(id: string): Promise<ResetPasswordResult> {
  return api(`/api/admin/users/${id}/reset-password`, { method: 'POST' });
}

export function resetAdminTotp(id: string): Promise<ResetTotpResult> {
  return api(`/api/admin/users/${id}/reset-totp`, { method: 'POST' });
}

// Именно `json:`, а не `body: JSON.stringify(...)`: хелпер ставит Content-Type только для
// первого варианта. С сырым body fetch отправит text/plain, парсер Nest его пропустит,
// и до контроллера доедет пустое тело.
export function createAdmin(input: { email: string; name: string }): Promise<CreatedAdmin> {
  return api<CreatedAdmin>('/api/admin/users', { method: 'POST', json: input });
}

/**
 * Готовое сообщение новому админу: всё для входа одним куском, чтобы не собирать руками.
 * Секрет включаем текстом рядом с QR - на случай, когда человек не может отсканировать
 * (десктопный менеджер паролей, скриншот в переписке).
 */
export function buildWelcomeMessage(c: CreatedAdmin, loginUrl: string): string {
  return [
    `Доступ в админку Smena для ${c.user.name}.`,
    '',
    `Адрес:  ${loginUrl}`,
    `Логин:  ${c.user.email}`,
    `Пароль: ${c.password}`,
    '',
    'Второй фактор обязателен. Заведите код в аутентификаторе (Google Authenticator, Aegis, 1Password):',
    `  - отсканируйте QR из админки,`,
    `  - либо введите ключ вручную: ${c.totpSecret}`,
    '',
    'При входе спросят 6-значный код из приложения.',
    'Пароль и ключ показываются один раз - сохраните их в менеджер паролей.',
  ].join('\n');
}
